import React from 'react'
import { motion } from 'framer-motion'
import { staggerContainer } from '../utils/motion.js'

import { Socials, Navdots } from '../utils/components.js'

const Magazines = (Components, idName, className) =>
  function HOC() {
    return (
      <>
        <section
          className={` ${className} flex flex-row items-center justify-between z-0`}
          id={idName}
        >
          <Socials />

          <motion.section
            className={`${
              idName === 'about' ? 'flex-[0.8] m560:block hidden' : 'mx-auto '
            } `}
            variants={staggerContainer()}
            initial='hidden'
            whileInView='show'
            viewport={{ once: true, amount: 0.25 }}
          >
            <Components />
          </motion.section>

          <Navdots active={idName} />
        </section>
      </>
    )
  }

export default Magazines
